import { defineLocalStore } from '@/utils/localStore'
import { ref, watch, isRef, type Ref, type ComputedRef } from 'vue'

import {
  commentList as commentListRequest,
  commentCreate as commentCreateRequest,
  commentDelete as commentDeleteRequest,
  commentUpdate as commentUpdateRequest,
} from '@/requests/comments'
import { File } from '@/utils/types/helpers'
import { confirm } from 'best-modules/plugins'

type EntityIdInput = number | Ref<number> | ComputedRef<number>

export const { useLocalStore: useComments, initLocalStore: initComments } =
  defineLocalStore(
    'comments',
    (payload: { entityTypeId: number; entityId: EntityIdInput }) => {
      const { entityTypeId } = payload
      const entityIdRef = isRef(payload.entityId)
        ? payload.entityId
        : ref(payload.entityId)

      const commentList = ref<any[]>([])

      const getCommentList = () => {
        if (!entityIdRef.value) return
        return commentListRequest(entityTypeId, entityIdRef.value).then(res => {
          commentList.value = res.data
        })
      }

      watch(entityIdRef, newId => {
        if (newId) getCommentList()
      })

      const newComment = ref<string>('')

      const commentCreate = (documents: File[] = []) => {
        const comment = newComment.value.trim()
        if (!comment && !documents.length) return Promise.resolve()

        return commentCreateRequest({
          entityTypeId,
          entityId: entityIdRef.value,
          documents: documents.length ? documents : (null as any),
          comment,
        }).then(res => {
          commentList.value.push(res)
          newComment.value = ''
        })
      }

      const commentDelete = (commentId: number) => {
        return confirm({
          text: 'Ви впевнені що хочете видалити коментар назавжди?',
        }).then(() => {
          return commentDeleteRequest(commentId).then(() => {
            commentList.value = commentList.value.filter(
              c => c.id !== commentId
            )
          })
        })
      }

      const commentUpdate = (commentId: number, comment: string) => {
        return commentUpdateRequest(commentId, {
          comment,
          documents: null as any,
        }).then(updated => {
          const index = commentList.value.findIndex(c => c.id === commentId)
          if (index !== -1) {
            commentList.value[index] = updated
          }
        })
      }

      getCommentList()

      return {
        commentList,
        newComment,
        commentCreate,
        commentDelete,
        commentUpdate,
      }
    }
  )
